import React from "react";
import { selectSelection } from "../domain/selectors";
import { useEditorStore } from "../domain/redux/hooks";
import type { Selection } from "../domain/types";
import { BlockSettingsPanel } from "./BlockSettingsPanel";
import { ButtonRowSlotSettingsPanel } from "./ButtonRowSlotSettingsPanel";
import { ColumnSettingsPanel } from "./ColumnSettingsPanel";
import { GroupSettingsPanel } from "./GroupSettingsPanel";
import { RowSettingsPanel } from "./RowSettingsPanel";

type SettingsPanelProps = {
  panelSelection?: Selection;
};

export function emailBuilderSettingsSelectionKey(selection: Selection): string {
  return JSON.stringify(selection);
}

export function SettingsPanel(props: SettingsPanelProps) {
  const storeSelection = useEditorStore(selectSelection);
  const selection = props.panelSelection ?? storeSelection;

  if (selection.kind === "group") {
    return <GroupSettingsPanel groupId={selection.groupId} />;
  }

  if (selection.kind === "row") {
    return <RowSettingsPanel rowId={selection.rowId} />;
  }

  if (selection.kind === "column") {
    return (
      <ColumnSettingsPanel rowId={selection.rowId} columnId={selection.columnId} />
    );
  }

  if (selection.kind === "buttonRowSlot") {
    return (
      <ButtonRowSlotSettingsPanel
        rowId={selection.rowId}
        columnId={selection.columnId}
        blockId={selection.blockId}
        slotIndex={selection.slotIndex}
      />
    );
  }

  if (selection.kind === "block") {
    return (
      <BlockSettingsPanel
        rowId={selection.rowId}
        columnId={selection.columnId}
        blockId={selection.blockId}
      />
    );
  }

  return null;
}
